export const environment = {
  production: true,
  baseUrl: 'https://dev.agentic-system.elvoon.it/ingestion/api/v1',
  api: {
    search: '/api/v1',
    history: '/ingestion/api/v1/history',
    generatedDocuments: '/ingestion/api/v1/generated-documents',
    upload: 'documents/user-upload',
    status:'documents/status',
    presigned_url: 'files/presigned-url'
  },
  host: 'https://dev.agentic-system.elvoon.it',
  socketPath: '/ingestion/api/v1/task-socket',
  keycloak: {
    url: 'https://auth.dev.agentic-system.elvoon.it/',
    realm: 'agentic-system',
    clientId: 'web-console',
  },
};
